// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import ProductCategorySelector from "components/ProductCategorySelector"
import ProductInventory from "./ProductInventory"
import type { ProductVariant } from "data/product/types"
import { chooseProductGroups } from "data/app/actions"
import { selectProductGroups } from "data/app/selectors"
import { InventoryWrap } from "./styled"

/**
 * Render a Product Category selctor and a tile list of ProductVariants
 */
const InventorySelector = ({ inventory, validateInventory, chooseProductGroups, productGroups, selectInventoryItem }) => {
  validateInventory(inventory)
  return (
  <React.Fragment>
    <InventoryWrap>
      <ProductCategorySelector handleSelect={chooseProductGroups} />
      <ProductInventory
        productGroups={productGroups}
        selectedInventory={inventory}
        onSelect={selectInventoryItem}
      />
    </InventoryWrap>
  </React.Fragment>
)}

const mapStateToProps = state => ({
  productGroups: selectProductGroups(state),
})

const mapDispatchToProps = {
  chooseProductGroups,
}

type Outter = {
  inventory: ProductVariant[],
  setInventory: (ProductVariant[]) => void,
  validateInventory: (inventory: ProductVariant[]) => void,
}

const enhancer: HOC<*, Outter> = compose(
  withConnect(mapStateToProps, mapDispatchToProps),
  withHandlers({
      selectInventoryItem: props => selectedVariant => {
        // TODO(HARRY) Factor this
        let selectedItems = Array.from(props.inventory)
        const exists = selectedItems.filter(
          selectedItem => selectedItem.id === selectedVariant.id,
        )
        if (exists.length > 0) {
          selectedItems = selectedItems.filter(
            selectedItem => selectedItem.id !== selectedVariant.id,
          )
        } else {
          selectedItems.push(selectedVariant)
        }
        props.setInventory(selectedItems)
      }
    }
  )
)

export default enhancer(InventorySelector)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/InventorySelector/index.js